<template>
<div>
     <top></top>
    <navMenu></navMenu>
  <div class="inner">
    <!-- <Header></Header> -->
    <!-- <nav-img></nav-img> -->
    <navbar></navbar>
    <div class="main">
      <div class="banner">
        <aside-left class="aside_left"></aside-left>
        <!-- <shoucang-main class="shoucang_main"></shoucang-main> -->

        <div class="logwrapper" v-if="isshow">
          <div class="logbtn">
            <svg class="icon iconcssa" aria-hidden="true">
              <use xlink:href="#iconxierizhi"></use>
            </svg>
            <div class="logtitle logtitlea" @click="editlog">发表日志</div>
          </div>
          <el-tabs
            v-model="activeName"
            @tab-click="handleClick"
            class="loglist"
          >
            <el-tab-pane label="已发布" name="1">
              <pushlog :pushjour="journallist" @deljou="delemit"></pushlog>
              <zanwu v-show="logdata"></zanwu>
            </el-tab-pane>
            <el-tab-pane label="草稿箱" name="0">
              <pushlog :pushjour="journallist"></pushlog>
              <zanwu v-show="logdata"></zanwu>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="logwrapper" v-else>
          <pushlog :pushjour="journallist" @deljou="delemit"></pushlog>
          <zanwu v-show="logdata"></zanwu>
        </div>
        <advertising class="aside_left_two"></advertising>
      </div>
    </div>
    <div class="dingbu">
      <scroll-top></scroll-top>
    </div>
  </div>
</div>
  
</template>

<script>
import top from "@/components/common/top.vue";
import navMenu from "@/components/common/navMenu.vue";
// 引入主导航栏区域
import Header from "../../../components/space/Header";
// 引入主体背景区域
import NavImg from "../../../components/space/NavImg";
// 引入导航栏区域
import Navbar from "../../../components/space/Navbar";
// 引入侧边栏区域
import AsideLeft from "../../../components/space/Aside";
import Advertising from "../../../components/space/advertising";
// 引入右侧主体区域
// import ShoucangMain from "../../components/space/ShoucangMain";
import URL from "../../../api/index";
import pushlog from "../../../components/space/pushlog"; // 已发布
import zanwu from "../../../components/common/zanwu"; //暂无数据
import scrollTop from "../../../components/space/scrollTop";
import axios from "axios";
export default {
  data() {
    return {
      activeName: "1",
      loginfo: 1,
      logtype: "",
      journallist: "",
      logdata: false,
      iteminfo: "",
      userid: "",
      isshow: true,
      isstart: "start",
    };
  },
  components: {
    top,
    navMenu,
    Header,
    NavImg,
    Navbar,
    AsideLeft,
    zanwu,
    Advertising,
    pushlog,
    scrollTop,
  },
  created() {
    // 获取用户信息、
  },
  mounted() {
    localStorage.removeItem("isstart_journal");
    this.getRecordRjw(JSON.parse(localStorage.getItem("loginInfo")))
    this.UserInfo = JSON.parse(window.localStorage.getItem("info"));
    this.iteminfo = JSON.parse(window.localStorage.getItem("iteminfo"));
    if (this.iteminfo) {
      if (this.iteminfo.space_creater == undefined) {
        this.userid = this.iteminfo.user_id;
      } else {
        this.userid = this.iteminfo.space_creater;
      }
      this.isshow = false;
    } else {
      this.userid = this.UserInfo.user_id;
      this.isshow = true;
    }
    this.getjournal();
  },
  methods: {
    delemit(val) {
      this.getjournal();
    },
    //tab切换
    handleClick(tab) {
      this.loginfo = tab.name;
      this.getjournal();
    },
    //获取日志列表
    getjournal() {
      var journaldata = {
        token: this.UserInfo.token,
        user_id: this.userid,
        draft: this.loginfo,
      };
      this.$post(URL.getjournal, journaldata).then((res) => {
        // console.log(res)
        if (res.result) {
          this.journallist = res.result.list;
        
        }else{
            this.logdata = true;
        }
        // if (this.journallist == undefined) {
        //   this.logdata = false;
        // } else {
        //   this.logdata = true;
        // }
      });
    },
    //发表日志
    editlog() {
      this.$router.push({
        name: "editlog",
        query: {
          edittyle: 1,
        },
      });
    },
    //数据上报
    getRecordRjw(hh) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "studyspace_log",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了网络学习空间的日志",
          data: {
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id:  hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("space_traceid")),
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
  },
};
</script>

<style lang="less">
.box {
  padding-top: 20px;
}
.main {
  background-color: #f5f6f8;
  // min-height: 1000px;
  .banner {
    padding: 25px 0;
    margin: 0 auto;
    width: 1200px;
    overflow: hidden;
    .aside_left {
      float: left;
    }
    .shoucang_main {
      float: right;
      width: 877px;
    }
  }
  .aside_left_two {
    float: left;
    clear: left;
  }
}
.wrapper {
  margin: 20px auto !important;
}
.logwrapper {
  float: right;
  width: 877px;
}
.logbtn {
  width: 100%;
  height: 90px;
  margin-right: 16px;
  background: #fff url(../../../assets/fabiaoback.png) no-repeat center;
  background-size: 98%;
  border-radius: 4px;
  position: relative;
  cursor: pointer;
}
.iconcssa {
  position: absolute;
  left: 36%;
  top: 24px;
  width: 40px !important;
  height: 42px !important;
}
.logtitlea {
  color: #3c495c;
  font-size: 24px;
  line-height: 90px;
  text-align: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.loglist .el-tabs__nav {
  width: 185px;
  height: 32px;
  margin-top: 24px;
  background: #fff;
  border-radius: 16px;
}
.loglist .is-active {
  color: #fff !important;
  background: #2c84ff;
  border-radius: 16px;
}
.loglist .el-tabs__item {
  width: 50%;
  height: 32px;
  line-height: 32px;
  margin-right: 0;
  border-bottom: 0;
  text-align: center;
  padding: 0;
}
.loglist .el-tabs__item:last-child {
  margin-right: 0;
}
.loglist .el-tabs__active-bar {
  display: none;
}
.loglist .el-tabs__nav-wrap::after {
  display: none;
}
.loglist .el-tabs__header {
  height: 60px;
  margin: 0;
}
.havetitle {
  margin: 30px 0 15px;
  font-size: 14px;
  color: #8a8a8a;
}
.dingbu {
  position: fixed;
  bottom: 30px;
  right: 30px;
}
</style>
